import axios from "axios";

export const fetchAdminWorkflowInstances = () => axios.get("/admin/workflows/instances");

export const fetchMailjetWorkflowOptions = () => axios.get("/admin/workflows/mailjet/options");

export const createAdminWorkflowInstance = (payload) => axios.post("/admin/workflows/instances", payload);

export const updateAdminWorkflowInstance = (workflowId, payload) =>
  axios.patch(`/admin/workflows/instances/${workflowId}`, payload);

export const runAdminWorkflowInstance = (workflowId) =>
  axios.post(`/admin/workflows/instances/${workflowId}/run`);

const INTAKE_BASE = "/admin/workflows/self-registration-intake";

export const fetchSelfRegistrationIntakeSettings = () => axios.get(`${INTAKE_BASE}/settings`);

export const fetchSelfRegistrationIntakeOptions = (companyId) =>
  axios.get(`${INTAKE_BASE}/options`, { params: companyId ? { companyId } : {} });

export const saveSelfRegistrationIntakeSettings = (payload) =>
  axios.put(`${INTAKE_BASE}/settings`, payload);

export const fetchSelfRegistrationIntakes = (params = {}) =>
  axios.get(`${INTAKE_BASE}/intakes`, { params });

export const retrySelfRegistrationIntake = (intakeId) =>
  axios.post(`${INTAKE_BASE}/intakes/${intakeId}/retry`);
